/* v4.65 — selections add the existing variants together, with catalogue inventory. */
(() => {
  const init = (scope = document) => {
    scope.querySelectorAll('[data-garabato-form]').forEach((form) => {
      if (form.dataset.garabatoReady) return;
      form.dataset.garabatoReady = 'true';
      const button = form.querySelector('[data-garabato-submit]');
      const feedback = form.querySelector('[data-garabato-feedback]');
      const cartLink = form.querySelector('[data-garabato-cart]');
      if (!button) return;
      const defaultLabel = button.textContent.trim();

      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (button.disabled || form.getAttribute('aria-busy') === 'true') return;
        const items = Array.from(form.querySelectorAll('[data-garabato-variant]'), (input) => ({
          id: Number(input.value), quantity: 1
        }));
        if (!items.length || items.some((item) => !Number.isSafeInteger(item.id) || item.id <= 0)) return;
        button.disabled = true;
        button.textContent = button.dataset.addingLabel;
        form.setAttribute('aria-busy', 'true');
        feedback.textContent = '';
        feedback.classList.remove('has-error');
        cartLink.hidden = true;

        // Never retry a POST automatically: a network error can follow a successful add.
        try {
          const endpoint = new URL(form.action, window.location.href);
          endpoint.pathname = endpoint.pathname.replace(/\/$/, '').replace(/\.js$/, '') + '.js';
          const response = await fetch(endpoint.pathname, {
            method: 'POST', credentials: 'same-origin',
            headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
            body: JSON.stringify({ items })
          });
          const result = await response.json();
          if (!response.ok) {
            const detail = typeof result.description === 'string' ? result.description : '';
            throw new Error(detail || form.dataset.errorMessage);
          }
          feedback.textContent = button.dataset.addedLabel;
          cartLink.hidden = false;
          // A cart-counter failure must not turn a successful add into a failure.
          try {
            const root = window.Shopify?.routes?.root || '/';
            const cartResponse = await fetch(root + 'cart.js', {
              credentials: 'same-origin', headers: { Accept: 'application/json' }
            });
            if (cartResponse.ok) {
              const cart = await cartResponse.json();
              document.querySelectorAll('[data-cart-count]').forEach((el) => { el.textContent = cart.item_count; });
              document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
            }
          } catch (_) { /* The cart link remains usable. */ }
        } catch (error) {
          feedback.textContent = error.message && error.message !== 'Failed to fetch'
            ? error.message : form.dataset.errorMessage;
          feedback.classList.add('has-error');
          cartLink.hidden = false;
        } finally {
          button.disabled = false;
          button.textContent = defaultLabel;
          form.removeAttribute('aria-busy');
        }
      });
    });
  };
  init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
